import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const WarningModal = ({
  onConfirm,
  onCancel,
  permissionError,
  isLoading,
  theme,
  logoLight,
  jobTitle,
}) => {
  return (
    <div className='ai-interview-container'>
      {/* Same header as interview interface */}
      <div className='d-flex align-items-center justify-content-between w-100 position-fixed interview-header'>
        <div className='d-flex align-items-center'>
          <img
            role='button'
            onClick={onCancel}
            className='light-image ml-4'
            style={{ height: '50px' }}
            src={
              theme?.loginLogo && theme.loginLogo.url
                ? theme.loginLogo.url
                : logoLight
            }
            alt=''
          />
          <div className='job-title-header'>
            <h1 className='text-white m-0'>
              {jobTitle ? `AI Interview - ${jobTitle}` : 'AI Interview Setup'}
            </h1>
          </div>
        </div>
      </div>

      {/* Main content with same styling as interview */}
      <div
        className='d-flex flex-column justify-content-center align-items-center min-vh-100 text-white p-4'
        style={{ paddingTop: '100px' }}
      >
        <div className='text-center' style={{ maxWidth: '600px' }}>
          <FontAwesomeIcon
            icon={faCircleExclamation}
            size='4x'
            className='text-warning mb-4'
          />

          <div className='bg-secondary p-4 rounded mb-4'>
            <h4 className='text-warning mb-3'>Requirements</h4>
            <p className='mb-3'>This interview requires access to your:</p>
            <ul className='list-unstyled mb-3 text-dark'>
              <li>
                📷 <strong>Camera</strong> - To record your video
              </li>
              <li>
                🎤 <strong>Microphone</strong> - To record your audio
              </li>
              <li>
                🖥️ <strong>Screen Sharing</strong> - To record your screen
                activity
              </li>
            </ul>
          </div>

          <div className='bg-info p-4 rounded mb-4'>
            <h4 className='text-white mb-3'>Important Notes</h4>
            <ul className='list-unstyled text-left text-white'>
              <li>
                • The interview will automatically switch to{' '}
                <strong>fullscreen mode</strong>.
              </li>
              <li>
                • If you exit fullscreen, you will have{' '}
                <strong>10 seconds</strong> to return before the interview ends.
              </li>
              <li>
                • The entire session will be{' '}
                <strong>video and audio recorded</strong>.
              </li>
              <li>
                • To start answering, click the <strong>“Answer”</strong>{' '}
                button.
              </li>
              <li>
                • When finished, click <strong>“Submit Answer”</strong> to
                submit your response.
              </li>
              <li>
                • Some questions may have a <strong>time limit</strong>.
              </li>
              <li>
                • If time runs out, your current response will be automatically
                submitted.
              </li>
              <li>
                • Certain questions may allow you to{' '}
                <strong>type a written response too.</strong>
              </li>
            </ul>
          </div>

          {permissionError && (
            <div className='alert alert-danger mb-4'>
              <strong>⚠️ Error:</strong> {permissionError}
              <br />
              <small>
                Please refresh the page and allow all permissions when prompted.
              </small>
            </div>
          )}

          <div
            className='d-flex justify-content-center'
            style={{ gap: '1.5rem' }}
          >
            <button
              className='btn btn-secondary btn-lg px-4'
              onClick={onCancel}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              className='btn btn-success btn-lg px-4'
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span
                    className='spinner-border spinner-border-sm mr-2'
                    role='status'
                  ></span>
                  Setting up...
                </>
              ) : (
                'Start Interview'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WarningModal
